const loadedPackagesStored = JSON.parse(
  localStorage.getItem("loadedPackagesStored") as string
);
const initialState = loadedPackagesStored
  ? { loadedPackages: loadedPackagesStored }
  : { loadedPackages: {} };

export const loadedPackages = {
  namespaced: true,
  state: initialState,
  actions: {
    setLoadedPackages({ commit }: any, current: { data: any }) {
      commit("setLoadedPackages", current);
      localStorage.setItem(
        "loadedPackagesStored",
        JSON.stringify(this.state.loadedPackages.loadedPackages)
      );
    },
  },
  mutations: {
    setLoadedPackages(state: any, current: any) {
      state.loadedPackages = current.data;
    },
  },
};
